import { Button, Switch, Tab, Tabs, TextField, styled } from '@mui/material';
import React, { useState, useEffect, ChangeEvent } from 'react'
import dayjs, { Dayjs } from 'dayjs';
import CustomSelectWithSearch from '../../CustomSelectWithSearch';
import CouponLoader from '../../CouponLoader';
import CouponBox from '../../CouponBox';
import CouponConfigurableLabel from '../../CouponConfigurableLabel';
import DateTimeSelector from './DateTimeSelector';
import { updateActivePeriodCustomDates, updateActivePeriodDays, updateActivePeriodMonths, updateActivePeriodWeeks } from '../../../../../stateManagement/actions/manageCouponActions';
import DoneIcon from '@mui/icons-material/Done';
import { MONTHS, WEEKS, DAYS } from "../../../utils/utils"
import { generateDatesForWeeks } from "./RecurrenceService";
import store from "../../../../../../src/stateManagement/store";
import { useSelector } from 'react-redux';
import { weeksCalculator,monthIndexMapper, weekIndexMapper, dayIndexMapper, indexMonthMapper, indexWeekMapper, indexDayMapper } from "./RecurrenceService"
import { useCouponAlert } from '../../../context/CouponAlert';


type DateObject = {
    value: string;
    label: string;
};

interface KOCalenderProps {
    val: { [key: string]: string[] };
    setVal: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
    disableSelection: boolean;
    isDeleted: boolean;
}
function KOCalendar({ val, setVal, disableSelection, isDeleted }: KOCalenderProps) {
    const { startDate, endDate } = useSelector((state: any) => state?.manageCoupons?.data?.recurrence?.dateStartEnd);

    const [searchTextMonths, setSearchTextMonths] = useState<string>("");
    const [searchTextWeeks, setSearchTextWeeks] = useState<string>("");
    const [searchTextDays, setSearchTextDays] = useState<string>("");
    const [searchTextDates, setSearchTextDates] = useState<string>("");
    const [disableDays, setDisableDays] = useState<boolean>(false);
    const [disableCustomDates, setDisableCustomDates] = useState<boolean>(true);
    const [customDateToggle, setCustomDateToggle] = useState<boolean>(false);
    const [selectedMonths, setSelectedMonths] = useState<number[]>([]);
    const [selectedWeeks, setSelectedWeeks] = useState<number[]>([]);
    const [selectedDays, setSelectedDays] = useState<number[]>([]);
    const [availableMonths, setAvailableMonths] = useState<{ value: string; label: string }[]>([]);
    const [availableWeeks, setAvailableWeeks] = useState<{ value: string; label: string }[]>([]);
    const [availableDays, setAvailableDays] = useState<number[]>([]);
    const [selectedDates, setSelectedDates] = useState<string[]>([]);
    const [availableDates, setAvailableDates] = useState<DateObject[]>([]);

    const monthIndexMap = monthIndexMapper();
    const weekIndexMap = weekIndexMapper();
    const dayIndexMap = dayIndexMapper();
    const { showAlert } = useCouponAlert();


    /**
     * this function removes the dates that no longer are presend in the selected months and weeks
     * @param values 
     * @param type 
     */
    const removeUnwanted = (values: string[], type: string) => {
        let filteredValues: string[] = [];
        if (type === "months") {
            filteredValues = values.filter(value => !monthIndexMap[value]);
            setSelectedMonths([]);
            updateActivePeriodMonths([]);
        }
        else if (type === "weeks") {
            filteredValues = values.filter(value => !weekIndexMap[value]);
            setSelectedWeeks([]);
            updateActivePeriodWeeks([]);
        }
        else if (type === "days") {
            filteredValues = values.filter(value => dayIndexMap[value] === undefined);
            setSelectedDays([]);
            updateActivePeriodDays([]);
        }
        else if (type === "dates") {
            console.log("date check");

            filteredValues = values.filter(item =>
            (
                DAYS.some(day => day.value === item) ||
                WEEKS.some(week => week.value === item) ||
                MONTHS.some(month => month.value === item)
            )
            );
            setSelectedDates([]);
            updateActivePeriodCustomDates([]);
            console.log("date check", filteredValues);
        }
        // setVal(filteredValues);
        setVal(prevVal => ({ ...prevVal, [type]: filteredValues }));

    };

    const filterDates = (available: DateObject[], selected: string[]) => {
        let filteredValues: string[] = [];
        const availableString = available.map(date => date.value); // Convert DateObject array to string array
        let otherTimes = selected.filter(item =>
        (
            DAYS.some(day => day.value === item) ||
            WEEKS.some(week => week.value === item) ||
            MONTHS.some(month => month.value === item)
        )
        );
        selected.forEach((value) => {
            if (otherTimes.includes(value) || availableString.includes(value)) { // Use availableString array here
                filteredValues.push(value);
            }
        });
        setVal(prevVal => ({ ...prevVal, "dates": filteredValues }));
    };


    /**
     * it checks the current length of selected months generates a list of dates based on that
     */
    useEffect(() => {
        if (startDate && endDate) {
            const formattedStartDate = new Date(Date.parse(startDate));
            const formattedEndDate = new Date(Date.parse(endDate));
            let startMonth = formattedStartDate.getMonth()
            let endMonth = formattedEndDate.getMonth()
            const totalMonths = (formattedEndDate.getFullYear() - formattedStartDate.getFullYear()) * 12 +
                (formattedEndDate.getMonth() - formattedStartDate.getMonth()) + 1;

            // let selectedMonths =
            let monthBetween = Array.from({ length: totalMonths }, (_, index) => {
                const currentMonth = new Date(formattedStartDate.getFullYear(), formattedStartDate.getMonth() + index, 1);
                return currentMonth.getMonth();
            });

            const filteredMonths = MONTHS.filter((month, index) => monthBetween.includes(index));
            setAvailableMonths(filteredMonths);
            let availWeeks=weeksCalculator(monthBetween,formattedStartDate,formattedEndDate)
            let filterWeeks=WEEKS.filter((week,index)=>availWeeks.includes(index));
            setAvailableWeeks(filterWeeks);

        }
        if ((selectedMonths.length > 0 || startDate || endDate) && !disableCustomDates) {
            const datesForWeeks = generateDatesForWeeks(selectedMonths, selectedWeeks, startDate, endDate);
            setAvailableDates(datesForWeeks);
        }
        else {
            setAvailableDates([]);
            if (customDateToggle) {
                setCustomDateToggle(false);
            }
            setDisableCustomDates(true);
            setDisableDays(false);
        }
    }, [selectedWeeks, selectedMonths, startDate, endDate]);


    /**
     * this checnes the states for the local lists of selected dates,days,weeks,months when thee is a change in val
     */
    useEffect(() => {
        setSelectedMonths(val["months"] && val["months"].map((monthString: string) => monthIndexMap[monthString]));
        setSelectedWeeks(val["weeks"] && val["weeks"].map((dayString: string) => weekIndexMap[dayString]));
        setSelectedDays(val["days"] && val["days"].map((dayString: string) => dayIndexMap[dayString]));
        setSelectedDates(val["dates"] && val["dates"]);
    }, [val]);


    /**
     * this function handels the selection of days, dates,weeks,months and adds it to val
     * @param selectedItems 
     * @param type 
     */
    const onSelect = (selectedItems: string[], type: string) => {
        // setVal(selectedItems);

        console.log("selectedItems ", selectedItems.toString());
        const filteredMonths = selectedItems.map(month => MONTHS.findIndex(item => item.value === month)).filter(index => index !== -1) as number[];
        const filteredWeeks = selectedItems.map(week => WEEKS.findIndex(item => item.value === week)).filter(index => index !== -1) as number[];
        switch (type) {
            case 'months':
                setVal(prevVal => ({ ...prevVal, [type]: selectedItems }));
                updateActivePeriodMonths(filteredMonths);
                console.log(filteredMonths, "selectedMonths");
                break;
            case 'weeks':
                setVal(prevVal => ({ ...prevVal, [type]: selectedItems }));
                updateActivePeriodWeeks(filteredWeeks);
                console.log(filteredWeeks, "selectedWeeks");
                break;
            case 'days':
                const filteredDays = selectedItems.map(days => DAYS.findIndex(item => item.value === days)).filter(index => index !== -1) as number[];
                setVal(prevVal => ({ ...prevVal, [type]: selectedItems }));
                updateActivePeriodDays(filteredDays);
                console.log(filteredDays, "selectedDays");
                break;
            case 'dates':
                setVal(prevVal => ({ ...prevVal, [type]: selectedItems }));
                updateActivePeriodCustomDates(selectedItems);
                break;
            default:
                break;
        }
    }


    /**
     * this method handels the earch part for each selection field
     * @param e 
     * @param type 
     */
    const handleSearch = (e: ChangeEvent<HTMLInputElement>, type: string) => {
        switch (type) {
            case 'months':
                setSearchTextMonths(e.target.value);
                break;
            case 'weeks':
                setSearchTextWeeks(e.target.value);
                break;
            case 'days':
                setSearchTextDays(e.target.value);
                break;
            case 'dates':
                setSearchTextDates(e.target.value);
                break;
        }
    }

    /**
     * this handels the toggeling of date and days selecror as at once only 1 can be selected
     * @param e 
     */
    const switchCustomDateSelector = (e: ChangeEvent<HTMLInputElement>) => {
        console.log("toggler called");
        if (!disableSelection && (selectedMonths.length > 0 || startDate || endDate)) {
            console.log("in if 1");
            if (customDateToggle) {//true
                setCustomDateToggle(false);
                setDisableCustomDates(true);
                setDisableDays(false);
                // setSelectedDates([]);
                // updateActivePeriodCustomDates([])
                removeUnwanted(val["dates"], "dates")
            }
            else {
                setCustomDateToggle(true);
                const datesForWeeks = generateDatesForWeeks(selectedMonths, selectedWeeks, startDate, endDate);
                console.log("fill setAvailableDates switchCustomDateSelector");
                setAvailableDates(datesForWeeks);
                setDisableCustomDates(false);
                setDisableDays(true);
                // setSelectedDays([]);
                // updateActivePeriodDays([]);
                removeUnwanted(val["days"], "days")
            }
        }
        else {
            console.log("in else 1");
            setCustomDateToggle(false);
            setDisableCustomDates(true);
            // setDisableDays(true)
        }
    }
    const voidFunction = () => {
        return;
    }


    return (
        <div>

            <div style={{ display: 'flex', justifyContent: 'space-evenly', gap: '20px', flexDirection: "column" }}>
                <div>
                    <CouponBox disabled={disableSelection} showBorder={true} onBeforeOpen={() => { availableMonths.length === 0 ? showAlert("Please select Start and End Date", "warning") : voidFunction(); }} collapsible header={<><CouponConfigurableLabel text={'months'} style={{ color: 'inherit' }} /></>}>
                        <div>
                            <CustomSelectWithSearch options={availableMonths}
                                multiple={true}
                                label=''
                                handleChange={(selectedItems) => onSelect(selectedItems, 'months')}
                                selectedOptions={val["months"] ?? []}
                                handleSearch={(e: React.ChangeEvent<HTMLInputElement>) => handleSearch(e, 'months')}
                                ListComponentProps={{
                                    style: { height: '250px', overflow: 'scroll', fontFamily: "poppins" }
                                }}
                                showSelectedAsChip
                                searchText={searchTextMonths}
                                loadingIcon={<CouponLoader />}
                                countOfListItem={100}
                            />
                        </div>
                    </CouponBox>
                </div>
                <div>
                    <CouponBox disabled={disableSelection} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'weeks'} style={{ color: 'inherit' }} /></>}>
                        <div>
                            <CustomSelectWithSearch options={availableWeeks}
                                multiple={true}
                                label=''
                                handleChange={(selectedItems) => onSelect(selectedItems, 'weeks')}
                                selectedOptions={val["weeks"] ?? []}
                                // handleSearch={(query: string) => handleSearch(query, 'weeks')}
                                handleSearch={(e: React.ChangeEvent<HTMLInputElement>) => handleSearch(e, 'weeks')}
                                ListComponentProps={{
                                    style: { height: '250px', overflow: 'scroll', fontFamily: "poppins" }
                                }}
                                showSelectedAsChip
                                searchText={searchTextWeeks}
                                loadingIcon={<CouponLoader />}
                                countOfListItem={100}
                            />
                        </div>
                    </CouponBox>
                </div>
                <div>
                    <CouponBox disabled={disableSelection || disableDays} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'days'} style={{ color: 'inherit' }} /></>}>
                        <div>
                            <CustomSelectWithSearch options={DAYS}
                                multiple={true}
                                label=''
                                handleChange={(selectedItems) => onSelect(selectedItems, 'days')}
                                selectedOptions={val["days"] ?? []}
                                // handleSearch={handleSearch}
                                handleSearch={(e: React.ChangeEvent<HTMLInputElement>) => handleSearch(e, 'days')}
                                ListComponentProps={{
                                    style: { height: '250px', overflow: 'scroll' }
                                }}
                                showSelectedAsChip
                                searchText={searchTextDays}
                                loadingIcon={<CouponLoader />}
                                countOfListItem={100}
                            />
                        </div>
                    </CouponBox>
                </div>
                <div>
                    <CouponBox disabled={disableSelection || disableCustomDates} showBorder={true} collapsible header={<><CouponConfigurableLabel text={'Dates'} style={{ color: 'inherit' }} />
                        <span style={{ margin: '0 10px' }}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            <Switch onChange={switchCustomDateSelector} checked={customDateToggle && !isDeleted} />
                        </span>

                    </>}>
                        <div>
                            {availableDates.length > 0 ? (
                                <CustomSelectWithSearch
                                    options={availableDates}
                                    multiple={true}
                                    label=''
                                    handleChange={(selectedItems) => onSelect(selectedItems, 'dates')}
                                    selectedOptions={val["dates"] ?? []}
                                    // handleSearch={handleSearch}
                                    handleSearch={(e: React.ChangeEvent<HTMLInputElement>) => handleSearch(e, 'dates')}
                                    ListComponentProps={{
                                        style: { height: '250px', overflow: 'scroll' }
                                    }}
                                    showSelectedAsChip
                                    searchText={searchTextDates}
                                    loadingIcon={<CouponLoader />}
                                />
                            ) : (
                                <></>
                            )}

                        </div>
                    </CouponBox>
                </div>
            </div>
        </div>
    )
}

export default KOCalendar;